<template>
	<div style="min-width: 1100;">
		<div class="table-content ">
			<el-table class="box-card" @row-click="rowClick" :span-method="objectSpanMethod" ref="tableList"
			 :show-overflow-tooltip="showTootip" v-loading="loading"
			element-loading-text="数据加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.6)" :border="showBorder" :size="size" :data="tableData" stripe
			 style="width: 100%" :max-height="height" @selection-change="wselect">
				<el-table-column v-if="showSelect" type="selection" width="50" label="选择">
				</el-table-column>
				<el-table-column v-if="showXuhao" type="index" width="90" label="序号">
					<template slot-scope="scope">
						{{(currentPage-1)*num + scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column :sortable="item.sort" v-for="(item,key) in tableHead" :key="key" :prop="item.field" :label="item.title"
				 :width="item.width?item.width:'auto'">
					<template slot-scope="scope">
						<el-button :size="size" v-if="item.property=='button'" @click="click(scope)">{{item[item.property]}}</el-button>
						<el-input :size="size" v-else-if="item.property=='input'" v-model="scope.row[scope.column.property]"></el-input>
						<el-input :size="size" v-else-if="item.property=='textarea'" type="textarea" v-model="scope.row[scope.column.property]"></el-input>
						<el-date-picker :style="datePickerStyle" :size="size" v-else-if="item.property=='date'" v-model="scope.row[scope.column.property]"
						 type="date" placeholder="选择日期">
						</el-date-picker>
						<wg-table v-else-if="item.property=='wgtable'" :param="scope.row"></wg-table>
						<span v-else-if="'templet' in item" v-html="item.templet(scope.row)"></span>
						<span v-else>{{scope.row[scope.column.property]}}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="showCaozuo" fixed="right" label="操作" :width="caozuoWidth">
					<template slot-scope="scope">
						<listCz :childrenCom='childrenCom' :type='type' v-if="caozuoArr" :row="scope.row" :authority="authority" :param="caozuoArr[scope.$index]"></listCz>
						<listCaoZuoO :childrenCom='childrenCom' :type='type' v-else-if="otherCaozuo" :unlock="unlock" :row="scope.row" :authority="authority" :param="otherCaozuo"></listCaoZuoO>
						<list-cao-zuo :childrenCom='childrenCom' :type='type' v-else @shuaXin="changepage(currentPage)" :authority="authority" :row="scope.row" @click="caozuo"></list-cao-zuo>
					</template>
				</el-table-column>
			</el-table>
			<div class="page_list" v-if="showPage">
				<el-pagination :current-page.sync="currentPage" @current-change="changepage" @size-change="changepagesize"
				 background layout=" prev, pager, next, jumper, ->, total, sizes,slot" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import listCz from '@/components/sub/listCz'
	import listCaoZuo from '@/components/sub/listCaoZuo'
	import listCaoZuoO from '@/components/sub/listCaoZuoO'
	export default {
		components: {
			listCaoZuo,
			listCaoZuoO,
			listCz
		},
		data() {
			return {
				tableData: [],
				selectData: [],
				currentPage: 1,
				loading: false,
				num: 10,
				total: 0,
				//需要合并的数据,JSON
				mergeSpan: '',
				unlock:true,
			}
		},
		props: {
			caozuoArr: '',
			type: '',
			childrenCom: '',
			baseConfig: {
				type: Object ,
				default: () => ({})
			},
			tableHead: {
				type: Array,
				default: () => ([])
			},
			size: {
				type: String,
				default: 'medium'
			},
			datePickerStyle: {
				type: Object,
				default: () => ({
					width: '128px'
				})
			},
			showSelect: {
				type: Boolean,
				default: false
			},
			showCaozuo: {
				type: Boolean,
				default: false
			},
			otherCaozuo: {
				type: Object,
				default: undefined
			},
			showXuhao: {
				type: Boolean,
				default: true
			},
			showPage: {
				type: Boolean,
				default: true
			},
			showTootip: {
				type: Boolean,
				default: true
			},
			shuaXin: {
				type: Boolean,
				default: true
			},
			showBorder: {
				type: Boolean,
				default: false
			},
			height: {
				default: 800
			},
			caozuoWidth: {
				type: Number,
				default: 240
			},
			authority: {
				type: Object,
				default: () => ({})
			},

		},
		created() {
			this.changepage(1)
			console.log(this.tableData)
		},
		activated(){
			this.changepage(this.currentPage)
		},
		watch: {
			baseConfig: {
				handler(a, b) {
					console.log(b)
					console.log(a)
					this.changepage(1)
				},
				deep: true
			},
			shuaXin(a, b) {
				this.changepage(this.currentPage)
			},
			tableData(a, b) {
				this.Bus.$emit('tableData', a)
			},
			tableHead() {
				this.changepage(1)
			},
		},
		methods: {
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (this.mergeSpan) {
					let mergeObj = JSON.parse(this.mergeSpan)
					if (column.property in mergeObj) {
						if (row.isMerge) {
							return {
								rowspan: row.columnLength,
								colspan: 1
							}
						} else {
							return {
								rowspan: 0,
								colspan: 0
							}
						}
					} else {
						return {
							rowspan: 1,
							colspan: 1
						}
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},
			//需要合并单元格的处理方法
			needMerge(res, merge) {
				let data = res.data
				let arrRes = []
				for (let row of data) {
					//每一个合并单元格的基础数据
					let merges = row[merge.key]
					//每一行的公共数据
					let obj = {}

					for (let idx in row) {
						if (idx != merge.key) {
							obj[idx] = row[idx]
						}
					}
					this.mergeSpan = JSON.stringify(obj)
					for (let item of merges) {
						Object.assign(item, obj)
					}
					merges[0].isMerge = true
					merges[0].columnLength = merges.length
					//只需要对第0个对象添加外部数据即可
					arrRes = arrRes.concat(merges)
				}
				console.log(arrRes)
				res.data = arrRes
				return res
			},
			powerShuaXin() {
				this.changepage(this.currentPage)
			},
			getinfo() {
				//需要在当前页面请求
				let config = this.baseConfig
				console.log(config,'hahahsahsah')
				if ('httpPromise' in config) {
					config.data.page = this.currentPage ? this.currentPage : 1
					config.data.limit = this.num ? this.num : 10
					config.data.orderby = config.data.orderby ? config.data.orderby : 'created_at desc'
					this.httpBack(config.httpPromise(config.data), (res) => {
						if (config.merge) {
							let dd = this.needMerge(res, config.merge)
							this.setTableData(dd)
						} else {
							this.setTableData(res)
						}
						this.$emit("gainnum", res)
					})
				} else {
					this.setTableData(config)
				}
			},
			setTableData(res) {
				this.unlock = !this.unlock
				this.$store.state.currentTable = res
				this.$emit('wdata', res)
				this.total = res.count ? res.count : 0
				this.$set(this, 'tableData', this.killNull(res.data ? res.data : []))
				this.loading = false
			},
			//改变页码
			changepage(val) {
				if (val) {
					this.currentPage = val;
				}
				this.loading = true
				this.getinfo()
			},
			//改变每页多少条
			changepagesize(val) {
				if (val == this.num) {
					return false;
				}
				this.num = val;
				this.changepage(1)
			},
			click(scope) {
				this.$emit('buttonClick', scope)
			},
			wselect(data) {
				this.selectData = data
				this.$emit('select', data)
			},
			caozuo(val) {
				if (val == 'del') {
					//执行删除操作后需要更新数据
					this.changepage(1)
				}
				this.$emit('caozuoClick', val)
			},
			rowClick(val) {
				this.$emit('row-click', val)
			},
			killNull(val) {
				let list = (window.Panduanxx(val[0]) == 'array') ? val[0] : val
				for (let item of list) {
					for (let idx in item) {
						if (item[idx] == 'null' || item[idx] == null || item[idx] == 'undefined' || item[idx] == undefined) {
							item[idx] = ''
						}
					}
				}
				return list
			},
			getTableRef() {
				return this.$refs.tableList
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/globle/listTable.vue